import React from 'react'
import PropTypes from 'prop-types'
import { RadioButton } from 'loyal-react'

const PointsCashContainer = ({
  title,
  children,
  selectPointsCash,
  radioSelected
}) => (
  <div className='payment-item border-color-ui-3 col-12 mx-0 my-0'>
    <div className='row'>
      <div className='payment-item item h-auto col-12 border-color-ui-3'>
        <div className='row align-items-center h-100'>
          <RadioButton
            id='PointCash'
            name='PaymentMethod'
            label=''
            ariaLabelledby='cashPointsTxt'
            role='radio'
            value='PointCash'
            className='col-auto pl-0'
            onClick={selectPointsCash}
            defaultChecked={radioSelected}
          />
          <div className='col'>
            <p className='txt-body-sm' id='cashPointsTxt' aria-hidden='false'>
              {`Utilizar pontos e cartão de crédito `}
            </p>
          </div>
          {title}
        </div>
      </div>
      {children}
    </div>
  </div>
)

PointsCashContainer.propTypes = {
  title: PropTypes.element,
  children: PropTypes.element,
  selectPointsCash: PropTypes.func.isRequired,
  radioSelected: PropTypes.bool
}

export default PointsCashContainer



// WEBPACK FOOTER //
// ./src/features/Checkout/Payment/Body/PointsCash/PointsCashContainer.js